import React from "react";
import { Redirect } from "@reach/router";
import { ACTIVATION_BASE_URL } from "./constants";
import Step2Auth from "./containers/Step2Auth";
import Step3PaymentForm from "./containers/Step3Payment/Step3PaymentForm";
import AnimatedRouter from "../../components/animations/AnimatedRouter";
import ActivationNavigation from "./components/Navigation";
import Step1FindCode from "./containers/Step1Pod/Step1FindCode";
import Step1PodEnterCode from "./containers/Step1Pod/Step1PodEnterCode";
import Step1PodInfo from "./containers/Step1Pod/Step1PodInfo";
import Step3PaymentInfo from "./containers/Step3Payment/Step3PaymentInfo";
import Step4ActivationInfo from "./containers/Step4Activation/Step4ActivationInfo";
import Step4ActivationLight from "./containers/Step4Activation/Step4ActivationLight";
import Step4Activation from "./containers/Step4Activation/Step4Activation";
import Step5ConfirmationQuestion from "./containers/Step5Confirmation/Step5UnlockConfirmationQuestion";
import Step5TroubleShoot from "./containers/Step5Confirmation/Step5Troubleshoot";
import Step5TroubleShootScreen from "./containers/Step5Confirmation/Step5TroubleshootScreen";
import Step5TroubleShootBattery from "./containers/Step5Confirmation/Step5TroubleshootBattery";
import Step5TroubleShootPodKey from "./containers/Step5Confirmation/Step5TroubleshootPodKey";
import Step4ActivationLightHelp from "./containers/Step4Activation/Step4ActivationLightHelp";
import Step4ActivationLightHelpBattery from "./containers/Step4Activation/Step4ActivationHelpBattery";
import { ActivationQueryData_datoCmsActivationConfig as ActivationConfigType } from "../../pages/__generated__/ActivationQueryData";
import ConfigProvider from "./providers/config-provider";
import Step4ActivationWhy from "./containers/Step4Activation/Step4ActivationWhy";
import Step5TroubleshootReEnterPodKey from "./containers/Step5Confirmation/Step5TroubleshootReEnterPodKey";
import Step5UnlockComplete from "./containers/Step5Confirmation/Step5UnlockComplete";
import Step5ReferralInstructions from "./containers/Step5Confirmation/Step5ReferralInstructions";
import NavigationStateProvider from "./providers/navigation-state-provider";
import usePreventTouchMove from "./hooks/usePreventTouchMove";

type Props = {
  config: ActivationConfigType;
};

export default function Activation({ config }: Props) {
  usePreventTouchMove(); // Prevent mobile device pinch zoom during activation
  return (
    <NavigationStateProvider>
      <ActivationNavigation />
      <ConfigProvider config={config}>
        <AnimatedRouter basepath={ACTIVATION_BASE_URL}>
          <Step1FindCode path="/" />
          <Step1PodEnterCode path="/enter-code" />
          <Step1PodInfo path="/:podKeyOrSerialNumber" />
          <Step2Auth path="/:podKeyOrSerialNumber/register" />
          <Step2Auth path="/:podKeyOrSerialNumber/sign-in" />
          <Step3PaymentInfo path="/:podKeyOrSerialNumber/payment-info" />
          <Step3PaymentForm path="/:podKeyOrSerialNumber/payment" />
          <Step4ActivationInfo path="/:podKeyOrSerialNumber/activation-info" />
          <Step4ActivationLight path="/:podKeyOrSerialNumber/activation-light" />
          <Step4ActivationLightHelp path="/:podKeyOrSerialNumber/activation-help" />
          <Step4ActivationLightHelpBattery path="/:podKeyOrSerialNumber/activation-help-battery" />
          <Step4Activation path="/:podKeyOrSerialNumber/activation" />
          <Step4ActivationWhy path="/:podKeyOrSerialNumber/activation-why" />
          <Step5ConfirmationQuestion path="/:podKeyOrSerialNumber/confirmation" />
          <Step5TroubleShoot path="/:podKeyOrSerialNumber/troubleshoot" />
          <Step5TroubleShootScreen path="/:podKeyOrSerialNumber/troubleshoot-screen" />
          <Step5TroubleShootBattery path="/:podKeyOrSerialNumber/troubleshoot-battery" />
          <Step5TroubleShootPodKey path="/:podKeyOrSerialNumber/troubleshoot-pod" />
          <Step5TroubleshootReEnterPodKey path="/:podKeyOrSerialNumber/troubleshoot-reenter-pod" />
          <Step5UnlockComplete path="/:podKeyOrSerialNumber/complete" />
          <Step5ReferralInstructions path="/:podKeyOrSerialNumber/referral" />
          <Redirect from="/*" to={`${ACTIVATION_BASE_URL}/`} noThrow />
        </AnimatedRouter>
      </ConfigProvider>
    </NavigationStateProvider>
  );
}
